import React from 'react';
import { cssMap } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { MorphingShapeLoader } from '@atlassian/rovo-platform-ui-components/primitives/MorphingShapeLoader';
import { EllipsesAnimation } from '@atlassian/rovo-platform-ui-components/primitives/EllipsesAnimation';
import { ShimmerText } from '@atlassian/rovo-platform-ui-components/primitives/ShimmerText';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: token('space.200'),
		height: '100%',
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
	},
});

const i18n = defineMessages({
	preparingSuggestions: {
		id: 'suggestions-panel.published.loading.preparing-suggestions',
		defaultMessage: 'Preparing suggestions',
		description:
			'Loading message shown in the AI suggestions panel on a published page while suggestions load. Animated dots are appended by the UI.',
	},
});

export const SUGGESTIONS_INITIAL_LOADING_TESTID = 'suggestions-initial-loading';

export const SuggestionsInitialLoading = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<div css={styles.container} role="status" data-testid={SUGGESTIONS_INITIAL_LOADING_TESTID}>
			<MorphingShapeLoader testId="suggestions-initial-loading-indicator" size="large" />
			<ShimmerText size="medium">
				{formatMessage(i18n.preparingSuggestions)}
				<EllipsesAnimation isAnimated />
			</ShimmerText>
		</div>
	);
};
